var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FeatureItem from './FeatureItem';
export default function ListFeatureIndex(_a) {
    var listFeaturesArray = _a.listFeaturesArray, setActiveContentInformation = _a.setActiveContentInformation, itemActiveFromMobile = _a.itemActiveFromMobile, setActivationFromMobile = _a.setActivationFromMobile, nativeMainRef = _a.nativeMainRef, activeContentInformation = _a.activeContentInformation;
    var renderFeatureItems = function (listItems) {
        return listItems
            .sort(function (a, b) { return a.order - b.order; })
            .map(function (featureObject, index) { return (_jsx(FeatureItem, { itemActiveFromMobile: itemActiveFromMobile, setActivationFromMobile: setActivationFromMobile, featureObject: featureObject, activeContentInformation: activeContentInformation, setActiveContentInformation: setActiveContentInformation }, index)); });
    };
    var deactivateAllItems = function () {
        var isMobileViewport = window.visualViewport.width < 1024;
        if (!isMobileViewport) {
            setActiveContentInformation(null);
            setActivationFromMobile(null);
        }
    };
    return (_jsx("div", __assign({ className: "jobs__column jobs__column__features relative w-full   lg:h-full lg:max-h-screen lg:overflow-y-scroll", ref: nativeMainRef }, { children: _jsxs("ul", __assign({ className: "jobs__features__list list-none lg:w-fit", onMouseLeave: deactivateAllItems }, { children: [_jsx("li", __assign({ className: "jobs__features__item relative" }, { children: _jsx("span", { className: "jobs__features__divider jobs__features__divider1 absolute top-0 h-0.5 w-full border-item" }, void 0) }), void 0), renderFeatureItems(listFeaturesArray)] }), void 0) }), void 0));
}
